import React, { Component } from 'react'
import './Selector.css'

class Selector extends Component {
  render() {
    const { options, selected, onSelect, optionClassName } = this.props
    return (
      <div className='Selector'>{
        options.map(
          option => <div
            key={option.id}
            className={
              `${optionClassName || 'Selector-option'} ${option.id === selected ? 'Selector-selected' : ''} ${option.customClassName || ''}`
            }
            onClick={() => onSelect(option.id)}
          >{typeof option.label === 'function' ? option.label(option) : option.label}</div>
        )
      }</div>
    )
  }
}

export default Selector


// WEBPACK FOOTER //
// ./src/Selector.js